import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Box, Flex, Text } from '@chakra-ui/react';

import { useCreateJob } from '@/features/jobs/api/jobQueries';
import { JobForm } from '@/features/jobs/components/JobForm';
import { Button } from '@/components/ui/Button';

export const Route = createFileRoute('/_authenticated/jobs/new')({
  component: JobNewPage,
});

function JobNewPage() {
  const navigate = useNavigate();
  const createMutation = useCreateJob();

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          求人新規作成
        </Text>
        <Button variant="outline" onClick={() => navigate({ to: '/jobs' })}>
          一覧に戻る
        </Button>
      </Flex>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
        <JobForm
          mode="create"
          onSubmit={async (values) => {
            await createMutation.mutateAsync(values);
            navigate({ to: '/jobs' });
          }}
          submitLabel="作成"
        />
      </Box>
    </Box>
  );
}
